// Tytuł ogłoszenia pojazdu: marka, model i wersja silnikowa — podgląd w formularzu dodawania i karty list.
export default function vehicleTitle (make, model, trim) {
    return [make, model, trim].map(v => (v == null ? '' : String(v).trim())).filter(Boolean).join(' ')
}
